import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const STEPS = [
    {
        num: "01",
        name: "Creator Content",
        desc: "High-velocity UGC and authentic creator storytelling.",
    },
    {
        num: "02",
        name: "Organic Signal",
        desc: "Identify the top-performing creative variations via engagement metrics.",
    },
    {
        num: "03",
        name: "Paid Amplification",
        desc: "Whitelist creator handles and put paid media budget behind winning creative.",
    },
    {
        num: "04",
        name: "Optimize & Reinvest",
        desc: "Scale high-ROAS ad sets and continuously feed in fresh creator hooks.",
    },
];

export default function Engine() {
    return (
        <section id="engine" data-testid="engine-section" className="relative overflow-hidden bg-navy py-16 sm:py-24">
            <div
                className="hero-glow pointer-events-none absolute inset-0 opacity-60"
                aria-hidden="true"
            />
            <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
                <Reveal className="mb-12 max-w-3xl">
                    <Eyebrow>The integrated engine</Eyebrow>
                    <h2 className="mt-4 font-syne text-3xl font-bold tracking-tight text-white sm:text-5xl">
                        Creator content in.
                        <br />
                        Compounding ROAS out.
                    </h2>
                    <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg">
                        One loop instead of two vendors: organic creator signal feeds paid
                        media, and paid results feed the next round of creator content.
                    </p>
                </Reveal>

                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.num} delay={i * 0.1} className="h-full" testid={`engine-step-${i + 1}`}>
                            <div className="group relative flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur transition-all duration-300 hover:-translate-y-1 hover:border-crimson/40 hover:bg-white/[0.07]">
                                <div className="mb-8 flex items-center justify-between">
                                    <span className="font-mono text-sm font-medium text-crimson">
                                        {s.num}
                                    </span>
                                    <ArrowRight className="h-4 w-4 text-slate-600 transition-all duration-300 group-hover:translate-x-1 group-hover:text-crimson" />
                                </div>
                                <h3 className="font-syne text-xl font-bold tracking-tight text-white">
                                    {s.name}
                                </h3>
                                <p className="mt-2.5 text-sm leading-relaxed text-slate-400">
                                    {s.desc}
                                </p>
                                {i < STEPS.length - 1 && (
                                    <span
                                        className="absolute -right-3 top-1/2 z-10 hidden h-px w-2.5 bg-white/20 xl:block"
                                        aria-hidden="true"
                                    />
                                )}
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
